import styled from 'styled-components';
import {
  blue, tekoMedium, openSansLight, darkerGrey, lightBlue,
} from '../../../utils/theme';

import { mobile } from '../../../utils/breakpoints';

export const TextWrapper = styled.div`
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-position: right;
  background-size: cover;
  background-repeat: no-repeat;

  &.left-aligned {
    text-align: left;
  }
  &.center-aligned {
    text-align: center;
  }
  &.right-aligned {
    text-align: right;
  }
`;

export const TextInner = styled.div`
  margin: 0 auto;
  padding: 70px;
  max-width: 1200px;

  > a {
    margin-top: 20px;
  }

  .title-image {
    margin-left: -45px;
  }

  .title {
    color: ${blue};
    ${tekoMedium} font-size: 60px;
    letter-spacing: 6.32px;
    text-transform: uppercase;
    text-align: left;

    @media (max-width: ${mobile.max}px) {
      font-size: 36px;
    }
  }

  @media (max-width: ${mobile.max}px) {
    padding: 30px;
  }
`;

export const RichTextWrapper = styled.div`
  .left-aligned & {
    * {
      text-align: left;
    }
  }
  .center-aligned & {
    * {
      text-align: center;
    }
  }
  .right-aligned & {
    * {
      text-align: right;
    }
  }

  li {
    ${openSansLight} font-size: 14px;
  }

  * {
    ${openSansLight} font-size: 14px;
    color: ${darkerGrey};
  }

  a {
    color: ${lightBlue};
    text-decoration: underline;
  }
  p {
    margin-bottom: 5px;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    color: ${blue};
    ${tekoMedium};
  }

  h1 {
    font-size: 60px;
  }
  h2 {
    font-size: 50px;
  }
  h3 {
    font-size: 40px;
  }
  h4 {
    font-size: 30px;
  }
  h5 {
    font-size: 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/title-text/styles/titleAndText.style.js